module.exports = __webpack_public_path__ + "static/play_store-fe7cd2dbf7f1baddc4980c978ada0fe2.png";